import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { withLang } from "../../utils/langPath";

import cajero from "../../assets/images/home/cajeros.png";
import retail from "../../assets/images/home/retail.png";
import bancos from "../../assets/images/home/bancos.png";
import AnimatedElement from "../AnimatedElement";

const SUPPORTED_LANGS = ["es", "en"];

const ImageSection = () => {
  const { t } = useTranslation();
  const { lang: langFromUrl } = useParams();
  const currentLang = SUPPORTED_LANGS.includes(langFromUrl)
    ? langFromUrl
    : "es";

  // Slugs dinámicos
  const SLUGS =
    currentLang === "es"
      ? {
          banks: "bancos",
          retail: "retail",
          atms: "cajerosautomaticos",
        }
      : {
          banks: "banks",
          retail: "retail",
          atms: "atms",
        };

  const isMobile = window.innerWidth < 768;

  return (
    <section className="bg-color-blue md:pt-40 md:pb-48 pt-8 relative h-100% pb-8 overflow-hidden">
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-0 justify-items-center">
        {/* Imagen 1 (Bancos) */}
        <AnimatedElement fromDirection="custom" disableAnimation={isMobile}>
          <div className="flex flex-col items-center">
            <div className="relative rounded-full h-[10rem] w-[10rem] md:h-[25rem] md:w-[25rem] overflow-hidden">
              <img
                src={bancos}
                alt="bancos"
                className="object-cover w-full h-full rounded-full"
              />
              <div className="absolute inset-0 bg-black/40 rounded-full z-10" />
              <h2 className="absolute inset-0 z-20 flex items-center justify-center text-2xl font-bold text-white md:text-4xl md:top-[75%] md:left-1/2 md:transform md:-translate-x-1/2 md:inset-auto">
                <Link to={withLang(currentLang, SLUGS.banks)}>
                  {t("banks")}
                </Link>
              </h2>
            </div>
            <h3 className=" md:block mt-4 text-xl font-bold text-orange-600 md:text-2xl md:w-96 text-center">
              {t("banner.bannerImage1")}
            </h3>
          </div>
        </AnimatedElement>

        {/* Imagen 2 (Retail) */}
        <AnimatedElement fromDirection="custom2" disableAnimation={isMobile}>
          <div className="flex flex-col items-center">
            <div className="relative rounded-full h-[10rem] w-[10rem] md:h-[25rem] md:w-[25rem] overflow-hidden">
              <img
                src={retail}
                alt="retail"
                className="object-cover w-full h-full rounded-full"
              />
              <div className="absolute inset-0 bg-black/40 rounded-full z-10" />
              <h2 className="absolute inset-0 z-20 flex items-center justify-center text-2xl font-bold text-white md:text-4xl md:top-[75%] md:left-1/2 md:transform md:-translate-x-1/2 md:inset-auto">
                <Link to={withLang(currentLang, SLUGS.retail)}>
                  {t("retail")}
                </Link>
              </h2>
            </div>
            <h3 className=" md:block mt-4 text-xl font-bold text-orange-600 md:text-2xl md:w-96 text-center">
              {t("banner.bannerImage3")}
            </h3>
          </div>
        </AnimatedElement>

        {/* Imagen 3 (ATMs) */}
        <AnimatedElement
          fromDirection="custom2"
          disableAnimation={isMobile}
          className="md:col-span-2"
        >
          <div className="flex flex-col items-center">
            <div className="relative rounded-full h-[10rem] w-[10rem] md:h-[30rem] md:w-[30rem] mx-auto overflow-hidden">
              <img
                src={cajero}
                alt="cajeros"
                className="object-cover w-full h-full rounded-full"
              />
              <div className="absolute inset-0 bg-black/40 rounded-full z-10" />
              <h2 className="absolute inset-0 z-20 flex items-center justify-center text-2xl font-bold text-white md:text-4xl md:top-[75%] md:left-1/2 md:transform md:-translate-x-1/2 md:inset-auto">
                <Link to={withLang(currentLang, SLUGS.atms)}>{t("atms")}</Link>
              </h2>
            </div>
            <h3 className=" md:block mt-4 text-xl font-bold text-orange-600 md:text-2xl md:w-96 text-center">
              {t("banner.bannerImage2")}
            </h3>
          </div>
        </AnimatedElement>
      </div>

      {/* Texto "Tailor made solutions" */}
      <div className="text-left mt-16 md:mt-24 px-10">
        <AnimatedElement fromDirection="bottom" disableAnimation={isMobile}>
          <p className="text-white text-4xl md:text-6xl xl:text-8xl font-bold leading-tight">
            {t("banner.tailor")}
            <br />
            {t("banner.madeSolutions")}
          </p>
        </AnimatedElement>
      </div>
    </section>
  );
};

export default ImageSection;
